export const REPORT_CHART_COLORS = ['#0d6b66', '#3777b7', '#c98a1c', '#b1424d', '#735ca5', '#1b8298', '#28a765', '#6f829d'] as const;

export const reportChartColor = (index: number): string => REPORT_CHART_COLORS[index % REPORT_CHART_COLORS.length] ?? REPORT_CHART_COLORS[0];
